__webpack_require__.p = "//s3.meituan.net/static-prod01/ws-assets/com.sankuai.phoenixfrontend.activity/3rcx9egeFGXGM0vUToJ1P/verify-edu/";